import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';
import {HttpClientModule} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicIoModule } from 'ng-dynamic-component';
import {RouterModule, Route } from '@angular/router';
import { CLIENT_CONFIG, CLIENT_SERVICE, API_URL, INDEXED_DB_NAME, SOCKET_URL, ENVIRONMENT } from './services/constants';
import { NodeFooterButtonComponent } from './components/node-footer-button.component';
import { StoreModule } from '@ngrx/store';
import { wiloReducers } from './store';
import { NodeRouterComponent } from './components/node-router.component';
import { ClientConfig } from './models';
import { DecisionNodeComponent } from './components';
import { SocketIoModule } from 'ngx-socket-io';

interface Config {
  clientConfig: ClientConfig;
  clientService: any;
  api_url: string;
  indexedDbName: string;
  environment: any;
  socket_url?: string;
}


const coreModules = [
    DynamicModule,
    HttpClientModule,
    ReactiveFormsModule,
    DynamicIoModule,
    SocketIoModule
];
@NgModule({
  declarations: [
    NodeFooterButtonComponent,
    NodeRouterComponent,
    DecisionNodeComponent
  ],
  imports: [CommonModule, 
    StoreModule,
    // StoreModule.forFeature('dyn', wiloReducers), 
    RouterModule, ...coreModules],
  exports: [...coreModules, NodeRouterComponent, NodeFooterButtonComponent, RouterModule]
})
export class WiloModule {
  static config: Config = {} as Config;
  constructor(@Optional() @SkipSelf() parentModule: WiloModule) {
    if ( parentModule ) {
          throw new Error('WilowModule is already loaded. Import it in the AppModule only!');
      }
  }
  static forRoot(config: Config): ModuleWithProviders<WiloModule> {
    WiloModule.config = config;
    return {
      ngModule: WiloModule,
      providers: [
        {provide: CLIENT_CONFIG, useValue: config.clientConfig},
        {provide: CLIENT_SERVICE, useExisting: config.clientService},
        {provide: API_URL, useValue: config.api_url},
        {provide: INDEXED_DB_NAME, useValue: config.indexedDbName},
        {provide: ENVIRONMENT, useValue: config.environment},
        {provide: SOCKET_URL, useValue: config.socket_url || ''}
      ]
    };
  }

  static forFeature(): ModuleWithProviders<WiloModule> {
    const config = WiloModule.config;
    return {
      ngModule: WiloModule,
      providers: [
        {provide: CLIENT_CONFIG, useValue: config.clientConfig},
        {provide: CLIENT_SERVICE, useExisting: config.clientService},
        {provide: API_URL, useValue: config.api_url},
        {provide: INDEXED_DB_NAME, useValue: config.indexedDbName},
        {provide: ENVIRONMENT, useValue: config.environment},
        {provide: SOCKET_URL, useValue: config.socket_url}
      ]
    };
  }
 }
